import React from 'react';
import UpdatePasswordComponent from './update-password.component';

function UpdatePassword() {
    return <UpdatePasswordComponent />;
}

export default UpdatePassword;
